import request from '@/utils/request'

// const baseUrl = 'https://gw.chuangkit.com/openplatform'
// const baseUrl = '/openplatform'
const baseUrl = ''
const headers = {
  'Content-Type': 'application/json; charset=UTF-8'
}
// 批量更新消息阅读状态
export const sysMessageBatchUpdateReadStatus = params => {
  return request.post(baseUrl + '/api/sysMessage/batchUpdateReadStatus', params, { headers })
}
// 统计未读消息数量
export const sysMessageCountUnread = params => {
  return request.get(baseUrl + '/api/sysMessage/countUnread', { params })
}

// 根据ID查询消息详情
export const sysMessageGetById = params => {
  return request.get(baseUrl + `/api/sysMessage/getById/${params.id}`, { params })
}

// 分页查询消息列表
export const sysMessageList = params => {
  return request.post(baseUrl + '/api/sysMessage/list', params, { headers })
}
// 全部已读
export const sysMessageAllRead = params => {
  return request.get(baseUrl + `/api/sysMessage/allRead`, { params })
}
